import React, { useEffect } from "react";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { CustomSelect, InputTextarea } from "components/atoms";
import { Button } from "components/ui";
import { StatusManageUserAction } from "store/middlewares/user";
import { GetAllRejectReasonAction } from "store/middlewares/dataManagement/rejectReason";

const ModalBlockDeleteReason = ({ type, id, filter, userType }) => {
  const dispatch = useDispatch();
  const { rejectReasons } = useSelector((state) => state.rejectReasons);
  useEffect(() => {
    let mappedType = type;
    if (type === "deleted") {
      mappedType = "delete";
    } else if (type === "blocked") {
      mappedType = "block";
    }

    dispatch(GetAllRejectReasonAction({ type: mappedType, page: -1 }));
  }, [type, dispatch]);

  const options =
    rejectReasons?.result ?.filter((item) => item.is_active === true).map((item) => ({
      label: item.note,
      value: item.note,
    })) ?? [];
  const allOptions = [...options, { label: "Other", value: "other" }];
  const handleSubmit = (values) => {
   const { isOther, selectedOption, ...payload } = values;

    if (userType === "customer") {
      dispatch(
        StatusManageUserAction({
          ...payload,
          status: type,
          id: id,
          filter,
        }),
      );
    } else if (userType === "driver") {
      if (type === "blocked") {
        dispatch(
          StatusManageUserAction({
            ...payload,
            status: type,
            id: id,
            filter,
          }),
        );
      } else {
        dispatch(
          StatusManageUserAction({
            ...payload,
            status: type,
            id: id,
            filter,
          }),
        );
      }
    } else {
      if (type === "blocked") {
        dispatch(
          StatusManageUserAction({
            ...payload,
            status: type,
            id: id,
            filter,
          }),
        );
      } else {
        dispatch(
          StatusManageUserAction({
            ...payload,
            status: type,
            id: id,
            filter,
          }),
        );
      }
    }
  };

  const formik = useFormik({
    initialValues: {
      reason: "",
      isOther: false,
      selectedOption: "",
    },
    validationSchema: Yup.object({
      selectedOption: Yup.string().required("Please select the reason"),
      reason: Yup.string().when("selectedOption", {
        is: "other",
        then: (schema) =>
          schema
            .trim()
            .required("Reason is required")
            .max(250, "Reason cannot exceed 250 characters"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="mb-3">
        <label className="text-sm font-medium text-foreground mb-1 block">
          Select Reason
        </label>
        <CustomSelect
          className="w-full"
          val={formik.values.selectedOption}
          options={allOptions}
          placeholder="Select a reason"
          onChange={(value) => {
            formik.setFieldValue("selectedOption", value);

            if (value === "other") {
              formik.setFieldValue("reason", "");
              formik.setFieldValue("isOther", true);
            } else {
              formik.setFieldValue("reason", value);
              formik.setFieldValue("isOther", false);
            }

            setTimeout(() => {
              formik.setFieldError("selectedOption", undefined);
              formik.validateField("selectedOption");
            }, 0);
          }}
          onBlur={formik.handleBlur}
          error={formik.errors.selectedOption && formik.touched.selectedOption}
          errorMsg={formik.errors.selectedOption}
        />
      </div>
      {formik.values.isOther === true && (
        <InputTextarea
          textareaClassName="rounded-lg border border-solid border-zinc-400 w-full px-2 py-2 mt-2 no-scrollbar"
          label={"Reason"}
          isRequired={false}
          maxLength={255}
          name="reason"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.reason && formik.touched.reason}
          errorMsg={formik.errors.reason}
          value={formik.values.reason}
          placeholder="Enter reason"
        />
      )}
      <div className="flex justify-end">
        <Button size={"lg"} type={"submit"}>
          Submit
        </Button>
      </div>
    </form>
  );
};

export default ModalBlockDeleteReason;
